module.exports = __webpack_public_path__ + "assets/img/img-error.665ef8dc.png";